/**
 * @typedef RichmenuCommandOptions
 * @property {boolean} help
 * @property {boolean} version
 */
